import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

import { Button, Input } from 'antd';
import Page from 'components/Page';
import Table from 'components/Table';

import globalMessages from 'translations/messages';
import useFormatMessage from 'hooks/useFormatMessage';
import useUser from 'hooks/useUser';
import { useHistory } from 'react-router';
import DataSourceTypeLabel from 'components/DataSourceTypeLabel';
import PrivacySettingLabel from 'components/PrivacySettingLabel';

const QUERY = gql`
  query {
    dataSources {
      id      
      title
      type
      website {
        id
        lastActivityTimestamp
        trackVisitors
        useCookies
      }
      customer {
        id
        name
      }
    }
  }
`;

const columns = [
  {
    dataIndex: ['customer', 'name'],
    title: 'Account',
  },
  {
    dataIndex: 'title',
    title: 'Title',
  },
  {
    dataIndex: 'type',
    title: <FormattedMessage {...globalMessages.type} />,
    render: (type) => <DataSourceTypeLabel type={type} />,
  },
  {
    dataIndex: ['website', 'trackVisitors'],
    title: 'Tracking',
    render: (trackVisitors) => <PrivacySettingLabel value={trackVisitors} />,
  },
  {
    dataIndex: ['website', 'useCookies'],
    title: 'Cookies',
    render: (useCookies) => <PrivacySettingLabel value={useCookies} />,
  },
  {
    dataIndex: ['website', 'lastActivityTimestamp'],
    title: 'Last activity',
    type: 'datetime',
    defaultSortOrder: 'descend',
  },
];

const DataSources = () => {
  const $t = useFormatMessage();
  const { data, loading } = useQuery(QUERY);
  const [search, setSearch] = useState();
  const { changeCustomer } = useUser();
  const history = useHistory();

  const onView = async (record) => {
    await changeCustomer(record.customer.id);
    history.push(`/data-sources/${record.id}`);
  };

  const actions = (record) => (
    <Button onClick={() => onView(record)}>
      View
    </Button>
  );

  return (
    <Page>
      <Page.Header
        title={<FormattedMessage {...globalMessages.dataSources} />}
      />
      <Page.Content>
        <Input.Search
          onSearch={setSearch}
          allowClear
          placeholder={$t(globalMessages.search)}
          style={{ marginBottom: '1em' }}
        />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data?.dataSources}
          actions={actions}
          search={search}
        />
      </Page.Content>
    </Page>
  );
};

export default DataSources;
